import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const TaskOverviewCard = ({ task, navigateToTask }) => {
  const assignment = task?.assignments?.[0]; //Getting first assignment because we filtered tasks by current user
  const assignedByFullName = `${assignment?.assigned_by_first_name || ''} ${
    assignment?.assigned_by_last_name || ''
  }`.trim();

  const dueDate = assignment?.due_date; //TODO: find exact number of days until due date using current date and assignment.due_date

  return (
    <div className="task-overview-card w-full min-w-[600px] rounded-xl bg-white px-4 py-3">
      <div className="mb-3 flex w-full items-center justify-between">
        <div>
          <div className="font-500 text-primary-900">
            {task?.step_name
              ? `Step: ${task?.step_name}`
              : task?.substep_name
                ? `Substep: ${task.substep_name}`
                : ''}
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-neutral-600">
          <div
            className={cn(
              'flex items-center gap-1',
              dueDate !== null && dueDate <= 7 && 'text-danger-500',
              dueDate !== null && dueDate > 7 && dueDate <= 14 && 'text-warning-500'
            )}>
            {dueDate === null ? (
              'No due date'
            ) : dueDate === -1 ? (
              'Due date passed'
            ) : (
              <>
                <Icon
                  color={dueDate <= 7 ? 'danger' : dueDate <= 14 ? 'warning' : 'neutral'}
                  shade={600}
                  icon="timer-linear"
                />
                Due in {dueDate} days
              </>
            )}
          </div>
        </div>
      </div>
      <p className="mb-6 max-h-12 overflow-y-auto text-left text-sm text-neutral-600">
        {assignment?.note}
      </p>
      <div className="flex items-center justify-between border-b-0 border-l-0 border-r-0 border-t border-solid border-neutral-100 pt-3">
        <div className="flex items-center justify-center gap-2">
          Delegated By
          <div className="flex items-center gap-2 rounded-3xl border border-solid border-neutral-300 p-2">
            <Avatar fullName={assignedByFullName} />
            {assignedByFullName}
          </div>
        </div>
        <div>
          <Button
            text="Review"
            onClick={() =>
              navigateToTask({ substepCode: task?.substep_code, stepCode: task?.step_code })
            }
          />
        </div>
      </div>
    </div>
  );
};
export default TaskOverviewCard;
